import { render, staticRenderFns } from "./SubcategoryList.vue?vue&type=template&id=402d2dda&scoped=true"
import script from "./SubcategoryList.vue?vue&type=script&lang=js"
export * from "./SubcategoryList.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryList.vue?vue&type=style&index=0&id=402d2dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d2dda",
  null
  
)

export default component.exports